class PredictiveSearch extends HTMLElement {
    constructor() {
        super();

        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = document.getElementById('predictive-search-results');
        this.noPredictiveSearchResults = document.getElementById('predective-no-result');
        this.recommended_box = document.getElementById('recommended-search-box');
        this.parent_radio = this.querySelectorAll('input[name="parentCollection"]') || [];

        this.STOREFRONT_ACCESS_TOKEN = 'd33a4b064a0b452fb3fc8bc929626081';
        this.GRAPHQL_URL = 'https://paciotti-official.myshopify.com/api/2022-07/graphql.json';

        this.tags = {
            'man_radio_button': ['man-shoes', 'Man', 'Uomo'],
            'woman_radio_button': ['woman-shoes', 'Woman', 'Donna']
        };

        this.input.addEventListener('input', this.debounce((event) => {
            this.onChange(event);
        }, 300).bind(this));

        this.parent_radio.forEach(element => {
            element.addEventListener('change', (event) => {
                this.onChange(event);
            });
        });

        this.input.addEventListener("keydown", (event) => {
            if (event.isComposing || event.keyCode === 229) {
                this.querySelector('form_search').submit();
            }
        });

        this.template_row = document.getElementById('template-row-search');

        this.colors = [{
                "en": "BEIGE",
                "it": "BEIGE"
            },
            {
                "en": "BLACK",
                "it": "NERO"
            },
            {
                "en": "BLUE",
                "it": "BLU"
            },
            {
                "en": "BROWN",
                "it": "MARRONE"
            },
            {
                "en": "DENIM",
                "it": "DENIM"
            },
            {
                "en": "GREY",
                "it": "GRIGIO"
            },
            {
                "en": "IVORY",
                "it": "AVORIO"
            },
            {
                "en": "ORANGE",
                "it": "ARANCIONE"
            },
            {
                "en": "PINK",
                "it": "ROSA"
            },
            {
                "en": "RED",
                "it": "ROSSO"
            },
            {
                "en": "SILVER",
                "it": "ARGENTO"
            },
            {
                "en": "WHITE",
                "it": "BIANCO"
            },
            {
                "en": "YELLOW",
                "it": "GIALLO"
            },
            {
                "en": "BURGUNDY",
                "it": "BURGUNDY"
            },
            {
                "en": "BRONZE",
                "it": "BRONZO"
            },
            {
                "en": "DARK BROWN",
                "it": "MARRONE"
            },
            {
                "en": "GOLD",
                "it": "ORO"
            },
            {
                "en": "GREEN",
                "it": "VERDE"
            },
            {
                "en": "NAVY",
                "it": "NAVY"
            },
            {
                "en": "PLATINUM",
                "it": "PLATINO"
            },
            {
                "en": "VIOLET",
                "it": "VIOLA"
            },
            {
                "en": "NUDE",
                "it": "NUDE"
            },
            {
                "en": "ECRU",
                "it": "ECRU"
            },
            {
                "en": "ANTHRACITE",
                "it": "ANTHRACITE"
            },
            {
                "en": "CHESTNUT",
                "it": "CHESTNUT"
            },
            {
                "en": "LILAC",
                "it": "LILLA"
            },
            {
                "en": "OFF-WHITE",
                "it": "OFF-WHITE"
            },
            {
                "en": "BLACK/WHITE",
                "it": "NERO/BIANCO"
            },
            {
                "en": "BLACK/GREY",
                "it": "NERO/GRIGIO"
            },
            {
                "en": "BLACK/PINK",
                "it": "NERO/ROSA"
            },
            {
                "en": "ORCHID",
                "it": "ORCHIDEA"
            },
            {
                "en": "GRAY",
                "it": "GRIGIO"
            }
        ];
    }

    clear(value) {
        this.colors.forEach(color => {
            if (color.it === value.toUpperCase()) {
                value = color.en;
            }
        });

        return value;
    }

    onChange() {
        const searchTerm = this.input.value.trim();

        if (!searchTerm.length) {
            this.noPredictiveSearchResults.hidden = true;
            this.predictiveSearchResults.hidden = true;
            return;
        }

        let selected_tags = this.tags[this.querySelector('input[name="parentCollection"]:checked').id];

        this.executeQuery(searchTerm, selected_tags[1]);
    }

    renderProducts(search_results, searchTerm) {
        let counter = [];
        let max = '';
        let max_val = 0;
        let show_recommended = true;

        this.clearResults();

        search_results.forEach(row => {
            let product = row.node;

            this.renderRow(product);

            if (counter[product.title]) {
                counter[product.title]++;
            } else {
                counter[product.title] = 1;
            }

            if (searchTerm.toLowerCase() === product.title.toLowerCase()) {
                show_recommended = false;
            }
        });

        if (show_recommended) {
            for (var x in counter) {
                if (counter[x] > max_val) {
                    max = x;
                    max_val = counter[x];
                }
            }

            let locale = window.Shopify.locale !== 'en' ? `${window.Shopify.locale}/` : '';

            this.recommended_box.querySelector('#recommended-search').innerHTML =
                `<a href="https://${window.Shopify.shop}/${locale}search?type=product&q=${max}">${max} (${max_val})</a>`;

            this.recommended_box.hidden = false;
        } else {
            this.recommended_box.hidden = true;
        }

        if (search_results.length == 0) {
            this.noPredictiveSearchResults.hidden = false;
            this.predictiveSearchResults.hidden = true;
        } else {
            this.noPredictiveSearchResults.hidden = true;
            this.predictiveSearchResults.hidden = false;
        }
    }

    debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }

    renderRow(product) {
        let locale = window.Shopify.locale !== 'en' ? `/${window.Shopify.locale}` : '';

        let url = `https://${window.Shopify.shop}${locale}/products/${product.handle}`;

        let row = this.template_row.content.cloneNode(true);
        row.querySelectorAll('.predictive-search__item')[0].href = url;
        row.querySelectorAll('.predictive-search__image')[0].src = product.featuredImage.src;
        row.querySelectorAll('.predictive-search__image')[0].alt = product.featuredImage.alt;
        row.querySelectorAll('.predictive-search__item-heading')[0].innerHTML = product.title;

        this.predictiveSearchResults.querySelector('ul').appendChild(row);
    }

    clearResults() {
        let container = this.predictiveSearchResults.querySelector('ul');
        while (container.firstChild) {
            container.removeChild(container.firstChild);
        }
    }

    productQuery(value, type) {
        value = this.clear(value);

        return `{
            products(first: 50, query: "(title:${value}*) AND (tag:${type}) AND (available_for_sale:true)") {
              edges {
                node {
                    title
                    handle
                    description
                    featuredImage {
                        src
                        altText
                    }
                    availableForSale
                    productType
                    onlineStoreUrl
                    tags
                }
              }
            }
            collection1: collection(handle: "${type}") {
                products(first: 50,
                  filters: [{
                      productMetafield:{
                        namespace:"custom",
                        key:"color",
                        value:"${value.toUpperCase()}"
                      }
                    },
                      {
                        available: true
                      }
                  ]) {
                  edges {
                      node {
                          title
                          handle
                          description
                          featuredImage {
                              src
                              altText
                          }
                          availableForSale
                          productType
                          onlineStoreUrl
                          tags
                      }
                  }
                }
              }
              collection2: collection(handle: "${type}") {
                products(first: 50,
                  filters: [{
                      productMetafield:{
                        namespace:"custom",
                        key:"type",
                        value:"${value}"
                      }},{
                      available: true
                      }
                  ]) {
                  edges {
                      node {
                          title
                          handle
                          description
                          featuredImage {
                              src
                              altText
                          }
                          availableForSale
                          productType
                          onlineStoreUrl
                          tags
                      }
                  }
                }
              }
          }`;
    }

    executeQuery(searchTerm, type_selected) {
        fetch(this.GRAPHQL_URL, {
                'async': true,
                'crossDomain': true,
                'method': 'POST',
                'headers': {
                    'X-Shopify-Storefront-Access-Token': this.STOREFRONT_ACCESS_TOKEN,
                    'Content-Type': 'application/graphql',
                },
                'body': this.productQuery(searchTerm, type_selected)
            })
            .then(res => res.json())
            .then(results => {
                let products = results.data.products.edges;
                let merge = products.concat(results.data.collection1.products.edges).concat(results.data
                    .collection2.products.edges);
                this.renderProducts(merge, searchTerm);
            });
    }
}

/*exported window.customElements */
window.customElements.define('predictive-search', PredictiveSearch);
